import React from 'react';

import Search from 'components/Icon/Search';
import Music from 'components/Icon/Music';
import GraphBar from 'components/Icon/GraphBar';
import Group from 'components/Icon/Group';
import News from 'components/Icon/News';
import Help from 'components/Icon/Help';

const iconStyle = { width: 20, height: 20 };

export function renderIcon(option) {
  if (option.icon) {
    return <div className="SideNav__MenuItem__dynamic_icon" style={iconStyle} dangerouslySetInnerHTML={{ __html: option.icon }}/>;
  }

  switch(option.id) {
    case 'search':
      return <Search width={20} height={20} />;
    case 'discover':
      return <Music width={20} height={20} />;
    case 'browse':
      return <GraphBar width={20} height={20} />;
    case 'news':
      return <News width={20} height={20} />;
    case 'artists':
      return <Group width={20} height={20} />;
    default:
      return <Help width={20} height={20} />;
  }
}
